import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [openSettings, setOpenSettings] = useState(false);
  const open = () => setOpenSettings(true);
  const close = () => setOpenSettings(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home onOpenCookieSettings={open} />} />
          <Route path="/impressum" element={<ImpressumPage onOpenCookieSettings={open} />} />
          <Route path="/datenschutz" element={<DatenschutzPage onOpenCookieSettings={open} />} />
        </Routes>
        <CookieBanner openSettings={openSettings} onCloseSettings={close} />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
